// extracted by mini-css-extract-plugin
module.exports = {"separator":"styles_separator__PwrYA","title":"styles_title__2n90U"};